"use strict";
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
let notification;
let ApiException;
const init = (notificationService, ApiExceptionService) => {
    notification = notificationService;
    ApiException = ApiExceptionService;
};
exports.init = init;
// this error hander is extremely complicated because api that's returning errors does this in a many different ways
const handleErrorDisplay = (error, setValidationErrors) => {
    if (!notification) {
        throw new Error('Notification service not found, did you forget to initialize it?');
    }
    const parsed = JSON.parse(error.response);
    const errors = parsed.Errors ? parsed.Errors : parsed.errors;
    // if parsed.errors is present that means we have validation errors.
    if (errors) {
        if (setValidationErrors) {
            setValidationErrors(errors);
        }
        else {
            notification.error({
                message: 'Error',
                description: Object.keys(errors)
                    .map((e) => { var _a; return errors[e].Message || errors[e].message || ((_a = errors[e]) === null || _a === void 0 ? void 0 : _a.join(' ')); })
                    .join(' '),
            });
        }
    }
    else {
        // it can be either errorMessage or ErrorMessage
        const errorMessage = parsed.ErrorMessage ? parsed.ErrorMessage : parsed.errorMessage;
        // parsed.ErrorMessage is either string or object, if it fails parsing that means it's string
        try {
            const parsedErrorMessage = JSON.parse(errorMessage);
            if (Object.keys(parsedErrorMessage).every((prop) => Array.isArray(parsedErrorMessage[prop]))) {
                const parsedErrors = Object.keys(parsedErrorMessage)
                    .map((prop) => parsedErrorMessage[prop].join(' '))
                    .join(' ');
                notification.error({
                    message: 'Error',
                    description: `${error.status}: ${parsedErrors}`,
                });
            }
            else {
                const parsedErrors = Object.keys(parsedErrorMessage).map((prop) => ` ${prop}: ${typeof parsedErrorMessage[prop] === 'object' ? JSON.stringify(parsedErrorMessage[prop]) : parsedErrorMessage[prop]}`);
                notification.error({
                    message: 'Error',
                    description: `${error.status}: ${parsedErrors}`,
                });
            }
        }
        catch (e) {
            notification.error({
                message: 'Error',
                description: `${error.status}: ${errorMessage}`,
            });
        }
    }
};
function handleError(fetch, setValidationErrors) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield fetch();
        }
        catch (error) {
            if (!ApiException) {
                throw new Error('ApiException service not found, did you forget to initialize it?');
            }
            if (error instanceof ApiException) {
                handleErrorDisplay(error, setValidationErrors);
            }
            else {
                throw error;
            }
        }
    });
}
exports.default = handleError;
